export const backgroundColours = {
    white: 'bg-white',
    'grey-100': 'bg-grey-100',
    green: 'bg-green',
    'dark-green': 'bg-green-dark',
    'green-light': 'bg-green-light',
};

export const textColours = {
    white: 'text-white',
    'dark-green': 'text-green-dark',
    'light-green': 'text-green-light',
};
